var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { callable, UIComponent, createShorthandFactory, commonPropTypes, } from '../../lib';
import { iconBehavior } from '../../lib/accessibility/';
/**
 * An icon is a glyph used to represent something else.
 */
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.renderFontIcon = function (ElementType, classes, rest, accessibility) {
        return React.createElement(ElementType, __assign({ className: classes.root }, accessibility.attributes.root, rest));
    };
    Icon.prototype.renderSvgIcon = function (ElementType, svgIconDescriptor, classes, rest, accessibility) {
        return (React.createElement(ElementType, __assign({ className: classes.root }, accessibility.attributes.root, rest), svgIconDescriptor && callable(svgIconDescriptor)({ classes: classes })));
    };
    Icon.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest, accessibility = _a.accessibility, theme = _a.theme;
        var _b = theme.icons, icons = _b === void 0 ? {} : _b;
        var maybeIcon = icons[this.props.name];
        return maybeIcon && maybeIcon.isSvg
            ? this.renderSvgIcon(ElementType, maybeIcon.icon, classes, rest, accessibility)
            : this.renderFontIcon(ElementType, classes, rest, accessibility);
    };
    Icon.className = 'ui-icon';
    Icon.displayName = 'Icon';
    Icon.propTypes = __assign({}, commonPropTypes.createCommon({
        children: false,
        content: false,
        color: true,
    }), { accessibility: PropTypes.func, bordered: PropTypes.bool, circular: PropTypes.bool, disabled: PropTypes.bool, name: PropTypes.string, size: PropTypes.oneOf(['smallest', 'smaller', 'small', 'medium', 'large', 'larger', 'largest']), xSpacing: PropTypes.oneOf(['none', 'before', 'after', 'both']) });
    Icon.defaultProps = {
        as: 'span',
        size: 'medium',
        accessibility: iconBehavior,
    };
    return Icon;
}(UIComponent));
Icon.create = createShorthandFactory(Icon, 'name');
export default Icon;
